<template>
  <transition
    appear
    appear-class="before-enter"
    appear-active-class="transition-transform"
    name="slide-from-bottom"
    @after-leave="onAnimationComplete"
  >
    <div v-if="show" class="push-notification-success-toast">
      <div class="toast-content">
        <div class="toast-header">
          <h3 class="toast-title">ההתראות במכשיר הופעלו 💪</h3>
        </div>
        <p class="toast-body">
          אפשר לבחור כמה פעמים בשבוע ובאיזה שעה רוצים אותם בתפריט הגדרות המנוי
        </p>
        <div class="toast-actions">
          <button class="action-button" @click="handleNavigateToSettings">
            קחו אותי לשם
          </button>
          <button class="action-button" @click="closeToast">
            סגירה
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '@/event-bus/event-bus';

export default {
  name: 'PushNotificationSuccessToast',
  data() {
    return {
      show: true,
    };
  },
  methods: {
    handleNavigateToSettings() {
      this.closeToast();
      this.$router.push({ name: 'WhatsappAlerts' });
    },
    closeToast() {
      this.show = false;
    },
    onAnimationComplete() {
      EventBus.$emit('close-toaster');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/border-radius';

.push-notification-success-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 34px);
  max-width: 460px;
  background-color: $riseup-beige;
  border-radius: $ri-border-radius-medium;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;

  &.transition-transform {
    transition: transform 0.3s ease-out;
  }

  &.before-enter {
    transform: translate(-50%, calc(100% + 20px));
  }

  .toast-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .toast-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .toast-title {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    color: $riseup-dark_green;
    text-align: right;
    font-family: SimplerProBold, SimplerPro, sans-serif;
    white-space: nowrap;
    width: 100%;
  }

  .toast-body {
    margin: 0;
    font-size: 16px;
    line-height: 1.5;
    color: $riseup-dark_green;
    text-align: right;
  }

  .toast-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 8px;
  }

  .action-button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: normal;
    padding: 0;
    transition: opacity 0.2s ease;
    font-family: SimplerPro, sans-serif;
    color: $riseup-blue;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.6;
    }
  }
}

.slide-from-bottom-leave-active {
  transition: transform 0.3s ease-out;
}

.slide-from-bottom-leave-to {
  transform: translate(-50%, calc(100% + 20px));
}
</style>
